module.exports = __webpack_public_path__ + "static/media/storeCoupon.30d62fa6.png";